import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: ({ bannerSize }: any) => bannerSize,
    background: theme.palette.brand.greenDark,
  },
  cancel: {
    marginLeft: 'auto',
    marginRight: theme.spacing(1),
    width: 14,
    height: 14,
    color: 'white',
  },
}));

export default function Banner({
  bannerSize,
  onClose,
}: {
  bannerSize: number;
  onClose: () => any;
}) {
  const classes = useStyles({ bannerSize });
  return (
    <div className={classes.root}>
      <IconButton className={classes.cancel} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </div>
  );
}
